import {
  isCarolinoPlanId,
  normalizeCarolinoPlanId,
  type CarolinoPlanId,
} from './carolinoPlans';

export interface CarolinoTrackingFields {
  isCarolino: boolean;
  isBasico: boolean | null;
  isEssencial: boolean | null;
  isClassico: boolean | null;
  isEspecial: boolean | null;
}

const EMPTY_TRACKING: CarolinoTrackingFields = {
  isCarolino: false,
  isBasico: null,
  isEssencial: null,
  isClassico: null,
  isEspecial: null,
};

/**
 * Deriva os campos de tracking Carolino a partir da sugestão confirmada.
 * Quando Carolino, exatamente um plano deve ser true (Basico, Essencial, Classico ou Especial).
 */
export function getCarolinoTrackingFields(
  confirmedSuggestion?: string | null
): CarolinoTrackingFields {
  const suggestion = normalizeCarolinoPlanId(
    confirmedSuggestion ??
      (typeof localStorage !== 'undefined'
        ? localStorage.getItem('confirmedSuggestion')
        : null) ??
      ''
  );

  if (!isCarolinoPlanId(suggestion)) {
    return EMPTY_TRACKING;
  }

  const plan = suggestion as CarolinoPlanId;

  return {
    isCarolino: true,
    isBasico: plan === 'basico',
    isEssencial: plan === 'essencial',
    isClassico: plan === 'classico',
    isEspecial: plan === 'especial',
  };
}

export function carolinoTrackingFromEvento(evento: {
  isCarolino?: boolean | null;
  isBasico?: boolean | null;
  isEssencial?: boolean | null;
  isClassico?: boolean | null;
  isEspecial?: boolean | null;
}): CarolinoTrackingFields {
  if (evento.isCarolino !== true) {
    return EMPTY_TRACKING;
  }

  return {
    isCarolino: true,
    isBasico: evento.isBasico ?? null,
    isEssencial: evento.isEssencial ?? null,
    isClassico: evento.isClassico ?? null,
    isEspecial: evento.isEspecial ?? null,
  };
}
